<template>
    <el-drawer title="白名单" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close" append-to-body>
        <div class="drawer-content">
            <div class="page-filter-box">
                <el-row :gutter="20">
                    <el-col :span="14">
                        <el-input v-model="params.searchValue" size="small">
                            <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                                <el-option label="用户ID" :value="1"></el-option>
                                <el-option label="用户昵称" :value="2"></el-option>
                                <!-- <el-option label="用户姓名" :value="3"></el-option> -->
                                <el-option label="账号手机号" :value="4"></el-option>
								<el-option label="证件编号" :value="5"></el-option>
                            </el-select>
                        </el-input>
                    </el-col>
                    <el-col :span="10" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="page-btns-box">
                <el-button v-if="$utils.have('/activityTicketWhite/remove')" type="primary" size="small" @click="out('', 1)"
                    icon="el-icon-remove-outline">批量移除白名单</el-button>
                <el-button v-if="$utils.have('/activityTicketWhite/add')" type="primary" size="small"
                    @click="$refs.addWhitelist.show(goodsId, ticketId)"
                    icon="el-icon-circle-plus-outline">添加白名单用户</el-button>
                <el-button v-if="$utils.have('/activityTicketWhite/exportWhiteList')" type="primary" size="small"
                    @click="download()" :loading="downLoading" icon="el-icon-download">导出白名单</el-button>
                <el-button v-if="$utils.have('/activityTicketWhite/importWhiteList')" type="primary" size="small"
                    @click="$refs.importWhitelist.show(goodsId, ticketId)" icon="el-icon-upload2">导入白名单</el-button>
            </div>
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="userId" label="用户ID"></el-table-column>
                    <el-table-column prop="userName" label="用户昵称"></el-table-column>
                    <el-table-column prop="telephone" label="账号手机号"></el-table-column>
					<el-table-column prop="documentNumber" label="证件编号"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button v-if="$utils.have('/activityTicketWhite/remove')" type="text" size="small"
                                @click="out(scope.row.id, 2)">移除白名单</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="data" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
        <add-whitelist ref="addWhitelist" @onUpdate="getDataList()"></add-whitelist>
        <import-whitelist ref="importWhitelist" @onUpdate="reset()"></import-whitelist>
    </el-drawer>
</template>

<script>
import AddWhitelist from './add-whitelist.vue';
import ImportWhitelist from './import-whitelist.vue';
import { downloadFileTmp } from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    pageSize: 10,
    searchType: 1,
    searchValue: '',
}
export default {
    components: { AddWhitelist, ImportWhitelist },
    data() {
        return {
            drawerShow: false,
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
            },
            goodsId: '',
            ticketId: '',
            whiteListIds: [],
            listLoading: false,
            downLoading: false
        }
    },
    methods: {
        close() {
            this.params = {
                ...defaultParams,
            };
            this.data=null;
            this.dataList = [];
            this.whiteListIds = [];
            this.drawerShow = false;
        },
        show(goodsId, ticketId) {
            this.goodsId = goodsId;
            this.ticketId = ticketId;
            this.getDataList();
            this.drawerShow = true;
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                goodsId: this.goodsId,
                ticketId: this.ticketId
            }
            this.$request({
                url: "/activityTicketWhite/pageList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //全选、反选
        handleSelectionChange(val) {
            this.whiteListIds = val.map(v => v.id);
        },
        //移出白名单 type== 1 批量移除 type==2 是单个的移除
        out(id, type) {
            if (type == 1 && this.whiteListIds.length < 1) {
                return this.$message.warning('请选择需要移除的用户');
            } else {
                const _msg = '注意：移除白名单后用户不能购买此票品';
                var _arryids = [];
                if (type == 1) {
                    _arryids = this.whiteListIds
                } else {
                    _arryids.push(id)
                }

                this.$confirm(_msg, '确定要将用户移除白名单吗？', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/activityTicketWhite/remove',
                        method: 'POST',
                        data: {
                            goodsId: this.goodsId,
                            ticketId: this.ticketId,
                            whiteListIds: _arryids
                        },
                    }).then(res => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.listLoading = false;
                    });
                }).catch(() => { })
            }

        },
        //导出白名单
        download() {
            var now = this.$utils.formatDate((new Date().getTime()), 'yyyy-MM-dd HH:mm:ss');
            let filePath;
            this.downLoading = true;
            this.$request({
                url: '/activityTicketWhite/exportWhiteList',
                method: 'POST',
                data: {
                    ...this.params,
                    goodsId: this.goodsId,
                    ticketId: this.ticketId
                },
            }).then(res => {
                const { state, msg, result } = res.data;
                if (state == 1 && result) {
                    filePath = result.url;
                    downloadFileTmp(filePath, `${now}_${this.goodsId}_白名单.` + this.$utils.getFileType(filePath));
                    this.downLoading = false;
                } else {
                    this.downLoading = false;
                    return this.$message.error(msg || '下载失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            });
        },
    }
}
</script>

<style lang="scss" scoped></style>